<template>
  <msg-box
    :title="isEdit ? '修改组合' : '添加组合'"
    :visible="true"
    @cancel="cancel"
    @confirm="confirm"
  >
    <div class="content">
      <el-form ref="form" :model="form" size="mini" label-width="120px">
        <el-form-item label="视图列表：">
          <el-select
            placeholder="请选择"
            v-model="form.viewId"
            @change="viewChange"
          >
            <el-option
              v-for="(item, index) in viewData"
              :key="index"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视图节点树：">
          <div class="tree-box">
            <div>
              <el-checkbox v-model="checkAll" @change="checkAllChange"
                >全选</el-checkbox
              >
              <el-checkbox v-model="cascade">级联</el-checkbox>
            </div>
            <div style="padding: 4px 0px;">
              <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText"
              ></el-input>
            </div>
            <div class="flex-1">
              <el-tree
                ref="tree"
                node-key="id"
                :default-checked-keys="defaultCheckedKeys"
                style="height: 100%;"
                :data="treeData"
                show-checkbox
                :props="props"
                :filter-node-method="filterNode"
                :check-on-click-node="true"
                :check-strictly="!cascade"
                @check-change="treeCheckChange"
              >
              </el-tree>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="已选择：">
          <div class="list-box-head">
            <table>
              <tr>
                <td>节点集合</td>
                <td>可选数据项</td>
              </tr>
            </table>
          </div>
          <div class="list-box">
            <table>
              <tr v-for="(item, index) in measuresForTemp" :key="index">
                <td>
                  <div class="td-pad">
                    <el-tag
                      size="mini"
                      class="tag"
                      closable
                      v-for="(tag, key) in item.measures"
                      :key="key"
                      @close="tagClose(item, index, key, tag)"
                      >{{ tag.measureName }}</el-tag
                    >
                  </div>
                </td>
                <td>
                  <div class="td-pad">
                    <el-select
                      placeholder="请选择"
                      v-model="item.dataItem.id"
                      @change="dataItemChange($event, item)"
                      :data="getExpressions(item)"
                    >
                      <el-option-group
                        v-for="group in item.templateExpression"
                        :key="group.id"
                        :label="group.displayName"
                      >
                        <el-option
                          v-for="item in group.expressions"
                          :key="item.value"
                          :label="item.displayName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </msg-box>
</template>

<script>
import MsgBox from "./MsgBox";
import Api from "@common/api/index.js";
import tree from "@/utils/tree";
export default {
  props: ["isEdit", "data", "statistics"],
  components: { MsgBox },
  data() {
    return {
      viewData: [],
      filterText: "",
      // 是否全选
      checkAll: false,
      // 是否级联
      cascade: false,
      treeNodeData: [],
      treeData: [],
      defaultCheckedKeys: [],
      props: {
        label: "measureName",
        children: "children",
      },
      // 按模板分类  的选中节点数据
      templateExpressionGroup: {},
      expression: {},
      measuresForTemp: [],
      form: {
        viewId: -1,
        dataItem: {},
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.measuresForTemp = this.data;
    this.getAllViewData();
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.measureName.indexOf(value) !== -1;
    },
    // 获取所有的视图
    getAllViewData() {
      Api.view
        .getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res && res.data) {
            this.viewData = res.data;
            this.form.viewId = res.data[0].id;
            this.getViewNodeData(this.form.viewId);
          } else {
            this.viewData = [];
          }
        });
    },
    viewChange(id) {
      this.getViewNodeData(id);
    },
    tagClose(item, index, key, tag) {
      if (this.form.viewId === item.viewId) {
        let keys = [];
        for (let i = 0; i < item.measures.length; i++) {
          if (tag.id !== item.measures[i].id) {
            keys.push(item.measures[i].id);
          }
        }
        this.$refs["tree"].setCheckedKeys(keys, this.cascade);
      } else {
        if (item.measures.length === 1) {
          this.measuresForTemp.splice(index, 1);
        } else {
          item.measures.splice(key, 1);
        }
      }
    },
    // 获取视图的节点列表
    getViewNodeData(viewId) {
      // 获取当前视图能使用的模板公式
      let vm = this;
      const node = vm.viewData.find((c) => c.id === viewId);
      let apis = [];
      let apiTemps = [];
      let templateExpressionGroup = [];
      let expression = {};

      for (let i = 0; i < node.measureTemplateGroupRestriction.length; i++) {
        const element = node.measureTemplateGroupRestriction[i];
        apiTemps.push(Api.measure.getMeasureTemplates2(element.id));
      }

      Promise.all(apiTemps).then((tempResArr) => {
        // 获取所有模板
        for (let i = 0; i < tempResArr.length; i++) {
          for (let j = 0; j < tempResArr[i].data.length; j++) {
            const element = tempResArr[i].data[j];
            if (tempResArr[i] && tempResArr[i].data) {
              templateExpressionGroup.push({
                templateId: element.id,
                data: [],
              });
              apis.push(
                Api.measure.getMeasureExpressionTemplateGroups(element.id)
              );
            }
          }
        }
        // 获取所有模板公式分组
        Promise.all(apis).then((resArr) => {
          const apiGroups = [];
          let groupIds = [];
          for (let i = 0; i < resArr.length; i++) {
            const res = resArr[i];
            let groupData = [];
            if (res && res.data) {
              for (let j = 0; j < res.data.length; j++) {
                const group = res.data[j];
                // apiGroups.push(Api.measure.getMeasureExpressionTemplateItems(group.id))
                groupIds.push(group.id);
                groupData.push(group);
              }
            }
            templateExpressionGroup[i].data = groupData;
          }
          Api.measure
            .getMeasureExpressionTemplateItems2(JSON.stringify(groupIds))
            .then((resGroup) => {
              if (resGroup && resGroup.data) {
                for (let i = 0; i < resGroup.data.length; i++) {
                  const expressionItem = resGroup.data[i];
                  if (expression[expressionItem.groupId]) {
                    expression[expressionItem.groupId].push(expressionItem);
                  } else {
                    expression[expressionItem.groupId] = [expressionItem];
                  }
                }
              }

              vm.templateExpressionGroup[viewId] = templateExpressionGroup;
              vm.expression[viewId] = expression;
              Api.view.getViewTreeNodes(viewId).then((res) => {
                if (res && res.data) {
                  vm.treeNodeData = res.data;
                  vm.treeData = tree.creatTreeJson(res.data, "0");

                  // 设置默认选中的点
                  let defaultCheckedKeys = [];
                  for (let i = 0; i < vm.measuresForTemp.length; i++) {
                    if (vm.measuresForTemp[i].viewId === viewId) {
                      for (
                        let j = 0;
                        j < vm.measuresForTemp[i].measures.length;
                        j++
                      ) {
                        const element = vm.measuresForTemp[i].measures[j];
                        defaultCheckedKeys.push(element.id);
                      }
                    }
                  }
                  vm.defaultCheckedKeys = defaultCheckedKeys;
                } else {
                  vm.treeNodeData = [];
                  vm.treeData = [];
                  vm.defaultCheckedKeys = [];
                }
              });
            });
        });
      });
    },
    //全选
    checkAllChange(checkAll) {
      if (checkAll) {
        this.$refs.tree.setCheckedNodes(this.treeNodeData);
      } else {
        this.$refs.tree.setCheckedNodes([]);
      }
    },
    treeCheckChange(data, selected, sub) {
      // 取消选中
      if (!selected) {
        if (this.cascade) {
          this.cancelSelectedNodeForTree([data]);
        } else {
          this.cancelSelectedNode(data);
        }
      }
      const checkNodes = this.$refs.tree.getCheckedNodes();
      console.log(checkNodes);
      let measuresForTemp = JSON.parse(JSON.stringify(this.measuresForTemp));
      // 按模板就行分类
      for (let i = 0; i < checkNodes.length; i++) {
        const node = checkNodes[i];
        const measuresForTempIndex = measuresForTemp.findIndex(
          (c) =>
            c.measureTemplateId === node.measureTemplateId &&
            c.viewId === this.form.viewId
        );
        if (measuresForTempIndex > -1) {
          if (
            measuresForTemp[measuresForTempIndex].measures.findIndex(
              (c) => c.measureId === node.measureId
            ) === -1
          ) {
            measuresForTemp[measuresForTempIndex].measures.push(node);
          }
        } else {
          measuresForTemp.push({
            measureTemplateId: node.measureTemplateId,
            measures: [node],
            dataItem: { id: null },
            viewId: this.form.viewId,
          });
        }
      }
      // for (let i = 0; i < measuresForTemp.length; i++) {
      //   if (measuresForTemp[i].measures.length === 0) {
      //     measuresForTemp.splice(i, 1)
      //   }
      // }
      this.measuresForTemp = measuresForTemp;
    },
    cancelSelectedNodeForTree(data) {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.cancelSelectedNode(element);
        this.cancelSelectedNodeForTree(element.children);
      }
    },
    cancelSelectedNode(data) {
      const measuresForTempIndex = this.measuresForTemp.findIndex(
        (c) =>
          c.measureTemplateId === data.measureTemplateId &&
          c.viewId === this.form.viewId
      );
      const index = this.measuresForTemp[
        measuresForTempIndex
      ].measures.findIndex((c) => c.measureId === data.measureId);
      if (this.measuresForTemp[measuresForTempIndex].measures.length === 1) {
        if (this.measuresForTemp.length === 1) {
          this.measuresForTemp = [];
        } else {
          this.measuresForTemp.splice(measuresForTempIndex, 1);
        }
      } else {
        this.measuresForTemp[measuresForTempIndex].measures.splice(index, 1);
      }
      return;
    },
    getExpressions(item) {
      let vm = this;
      if (item.templateExpression) {
        return "";
      }
      const templateId = item.measureTemplateId;
      const viewId = item.viewId;
      const template = vm.templateExpressionGroup[viewId].find(
        (c) => c.templateId === templateId
      );
      if (!template) return;
      for (let i = 0; i < template.data.length; i++) {
        if (vm.expression[viewId][template.data[i].id] === undefined) {
          template.data[i].expressions = [];
        } else {
          template.data[i].expressions =
            vm.expression[viewId][template.data[i].id];
        }
      }

      // 筛选统计、采集的数据项
      for (let i = 0; i < template.data.length; i++) {
        const element = template.data[i];
        let data = [];
        for (let j = 0; j < element.expressions.length; j++) {
          const formula = element.expressions[j];
          const bol =
            (formula.pointCode + "").indexOf("100") > -1 &&
            (formula.pointCode + "").length >= 6;
          if (bol === vm.statistics) {
            data.push(formula);
          }
        }
        template.data[i].expressions = data;
      }
      item.templateExpression = template.data;
      return "";
    },
    dataItemChange(e, item) {
      const data = item.templateExpression;
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].expressions.length; j++) {
          const element = data[i].expressions[j];
          if (element.id === e) {
            console.log(e);
            item.dataItem = element;
            break;
          }
        }
      }
    },
    cancel() {
      let vm = this;
      vm.$emit("cancel");
    },
    confirm() {
      let vm = this;
      let bol = true;
      for (let i = 0; i < vm.measuresForTemp.length; i++) {
        const element = vm.measuresForTemp[i];
        if (element.dataItem.id === null) {
          bol = false;
          break;
        }
      }

      if (!bol) {
        this.$message({
          message: "请选择可选数据项",
          type: "warning",
        });
        return;
      }
      vm.$emit("confirm", vm.measuresForTemp);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 700px;
  height: 500px;
  text-align: left;
  padding: 0px 10px;
  .tree-box {
    height: 300px;
    display: flex;
    flex-flow: column;
  }
  .list-box-head {
    height: 34px;
  }
  .list-box {
    height: 96px;
    margin-top: -5px;
    overflow: auto;
  }
  .list-box-head {
    td {
      padding: 0px 6px;
    }
  }
  .list-box,
  .list-box-head {
    table {
      border-collapse: collapse;
      width: 100%;
      tr {
        td {
          .td-pad {
            padding: 6px;
          }
          &:first-child {
            width: 70%;
          }
        }
      }
    }
    table,
    th,
    td {
      border: 1px solid #eeeeee;
    }
  }
}
.flex-1 {
  flex: 1;
  overflow: auto;
}
.flex {
  display: flex;
}
.tag {
  margin-top: 6px;
  margin-right: 6px;
}
</style>
